
<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" attr.aria-roledescription="相片檢視器(按 ESC 離開)">
  <!-- Background of PhotoSwipe.
        It's a separate element as animating opacity is faster than rgba(). -->
  <div class="pswp__bg"></div>

  <!-- Slides wrapper with overflow:hidden. -->
  <div class="pswp__scroll-wrap">
    <!-- Container that holds slides.
        PhotoSwipe keeps only 3 of them in the DOM to save memory.
        Don't modify these 3 pswp__item elements, data is added later on. -->
    <div class="pswp__container">
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
    </div>
    <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
    <div class="pswp__ui pswp__ui--hidden">
      <div class="pswp__top-bar">
        <!--  Controls are self-explanatory. Order can be changed. -->
        <div class="pswp__counter"></div>
        <button class="pswp__button pswp__button--zoom" title="縮小/放大"><span class="sr-only">縮小/放大</span></button>
        <button class="pswp__button pswp__button--fs" title="切換全螢幕"><span class="sr-only">切換全螢幕</span></button>
        <button class="pswp__button pswp__button--download" title="下載">
          <i class="fa fa-download" aria-hidden="true" style="pointer-events: none;"></i><span class="sr-only">下載</span>
        </button>
        <button class="pswp__button pswp__button--share" title="分享"><span class="sr-only">分享</span></button>
        <button class="pswp__button pswp__button--close" title="關閉(ESC)"><span class="sr-only">關閉(ESC)</span></button>
        <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
        <!-- element will get class pswp__preloader--active when preloader is running -->
        <div class="pswp__preloader">
          <div class="pswp__preloader__icn">
            <div class="pswp__preloader__cut">
              <div class="pswp__preloader__donut"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
        <div class="pswp__share-tooltip"></div>
      </div>

      <div class="pswp__download-modal pswp__download-modal--hidden pswp__single-tap">
        <div class="pswp__download-tooltip">
          <ng-container *ngIf="downloadData">
            <ng-container *ngTemplateOutlet="downloadToolTipTmp ? downloadToolTipTmp : downloadToolTipDefaultTmp; context: {$implicit: downloadData}"></ng-container>
            <ng-template #downloadToolTipDefaultTmp let-downloadData>
              <div *ngIf="canDownload" class="tm_pswp-download">
                <a class="download-btn btn" title="{{ downloadData.title }}[另開新視窗]" target="_blank" href="{{ downloadData.src }}">
                  <span class="label">下載檔案</span>
                  <span class="format"><div>{{ downloadData.w }} x {{ downloadData.h }} 像素 {{ downloadData.fileExt }}</div></span>
                </a>
              </div>
              <div class="tm_pswp-info">
                <div class="tm_pswp-usage-info">
                  <!-- 版權提示  -->
                  <div *ngIf="downloadData.imageAuthorityImg || !downloadData.imageAuthorityUrl" class="tm_pswp-rights-tip">{{ downloadData.imageAuthMan ? '授權人：' + downloadData.imageAuthMan : '' }}<br>
                    {{ downloadData.imageAuthorityText }}
                    <!-- ICON  -->
                    <a *ngIf="downloadData.imageAuthorityImg" href="{{ downloadData.imageAuthorityUrl }}" target="_blank" class="tm_pswp-copyright copyright-link" title="{{ downloadData.imageAuthorityText }}[另開新視窗]">
                      <img src="{{ downloadData.imageAuthorityImg }}" alt="{{ downloadData.imageAuthorityText }}">
                    </a>
                  </div>
                  <div *ngIf="!downloadData.imageAuthorityImg && downloadData.imageAuthorityUrl" class="tm_pswp-rights-tip">{{ downloadData.imageAuthMan ? '授權人：' + downloadData.imageAuthMan : '' }}<br>
                    <a href="{{ downloadData.imageAuthorityUrl }}" target="_blank" class="copyright-link" title="{{ downloadData.imageAuthorityText }}[另開新視窗]">
                      {{ downloadData.imageAuthorityText }}
                    </a>
                  </div>
                  <div *ngIf="canDownload" class="tm_pswp-cite-tip" (click)="copyCitation()"><i class="fa fa-clone" aria-hidden="true"></i>&nbsp;複製</div>
                  <!-- 引用文字  -->
                  <div *ngIf="canDownload" class="tm_pswp-rights-citation" id="tm_pswp-rights-citation">{{downloadRightsCitation}}</div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>

      <button class="pswp__button pswp__button--arrow--left" title="上一張 (左箭頭)"><span class="sr-only">上一張 (左箭頭)</span></button>
      <button class="pswp__button pswp__button--arrow--right" title="下一張 (右箭頭)"><span class="sr-only">下一張 (右箭頭)</span></button>

      <div class="pswp__caption" [class.pswp__thumb-viewing]="isThumbnailOpened">
        <div class="pswp__caption__center"></div>
      </div>

      <div class="pswp__bottom-bar" [class.pswp__bottom-bar-open]="isOpened" *ngIf="showthumbnailBar">
        <div class="pswp__thumb-outer" #thumbOuter [class.pswp__thumb-viewing]="isThumbnailOpened">
          <div class="pswp__thumb-scroller" [class.pswp__thumb-scroller-touch-device]="isTouchDevice">
            <div class="pswp__thumb clearfix" #thumb>
              <ng-container *ngFor="let item of data; index as i">
                <div *ngIf="$any(item).src" class="pswp__thumb-item" [class.active]="currentIndex === i" (click)="viewIn(i, $event)">
                  <img src="{{ $any(item).msrc }}" alt="{{$any(item).alt}}">
                </div>
              </ng-container>
            </div>
          </div>
          <button class="pswp__toogle-thumb pswp__icon" title="顯示/隱藏小圖" (click)="toggleThumbnail()">
            <i class="fa fa-th" aria-hidden="true"></i><span class="sr-only">顯示/隱藏小圖</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
